import { cn } from '@lqa-frontend/ui-system';
import React from 'react';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
	return (
		<div
			data-slot="skeleton"
			className={cn('bg-outline-neutral animate-pulse rounded-s', className)}
			{...props}
		/>
	);
}

export { Skeleton };
